﻿export class Question {
    id: number;
    text: string;
    surveyID: number;
    languageID: number;
    surveyQuestionTypeId: string;
    ordinalNumber: number;
}